import { useQuery } from '@tanstack/react-query'
import { useAuth } from '@/features/auth/hooks/use-auth'
import { supabase } from '@/lib/supabase'
import type { Database } from '@/types.generated'
import type { JSX } from 'react/jsx-runtime'
import type { DashboardStatsProviderProps } from '@/types'
import { DashboardStatsContext } from './dashboard-stats-context-context'

export const DashboardStatsProvider = ({
  children,
}: DashboardStatsProviderProps): JSX.Element => {
  const { user } = useAuth()

  const { data: stats, isLoading } = useQuery({
    queryKey: ['dashboard-stats', user?.id],
    queryFn: async (): Promise<Database['public']['Functions']['get_dashboard_stats']['Returns'][0]> => {
      if (!user) throw new Error('Authentication required')

      const { data, error } = await supabase.rpc('get_dashboard_stats')

      if (error) throw error

      return data[0] ?? { active_cases: 0, pending_tasks: 0, upcoming_hearings: 0 }
    },
    enabled: Boolean(user),
  })

  return (
    <DashboardStatsContext.Provider
      value={{
        isLoading,
        stats,
      }}
    >
      {children}
    </DashboardStatsContext.Provider>
  )
}

// useDashboardStats hook moved to hooks/use-dashboard-stats.ts to fix Fast Refresh error
